import service from '@/utils/server';

const modName='/md/market/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const marketAdd = data => {
  return service({
    url: modName + 'marketAdd',
    method: 'post',
    data
  });
};

export const marketDetails = data => {
  return service({
    url: modName + 'details',
    method: 'post',
    data
  });
};

export const marketEdit = data => {
  return service({
    url: modName + 'marketEdit',
    method: 'post',
    data
  });
};





// WEBPACK FOOTER //
// ./src/page/md/market/api/index.js